import { useEffect, useState } from "react";
import ModalHeaderStyle from "../utility/component/styles/modalHeader";
import { useNavigate } from "react-router-dom";
import { CallAPIPromise } from "../billing/common";
import { useDispatch, useSelector } from "react-redux";
import { selectCompanyAddress } from "../utility/Redux/profile";
import { ExitButton, SaveButton } from "../utility/component/buttons";
import GeniustextInput from "../utility/component/mastertext";
import CompanyHelp from "../help/companyHelp";
import { setAlertWithTitle, setSpinnerLoading } from "../utility/Redux/modal";
import { selectToken } from "../utility/Redux/security";

const WhastappSenderSettings = () => {
  const [companyHelpStatus, setCompanyHelpStatus] = useState(false);
  const [settings, setSettings] = useState({
    otpVerification: false,
    mobileVerification: false,
    retailxCrossLogin: false,
    orderReceivedCompany: false,
    orderAcceptedCustomer: false,
    orderRejectedCustomer: false,
    orderDispatchedCustomer: false,
    billLinkCustomer: false,
    orderDeliveredOTP: false,
    orderAssignedDelivery: false,
    sendAppQrCompany: false,
  });
  const token = useSelector(selectToken);
  const [whatsappBalance, setWhastappBalance] = useState(0);

  const [companyDetails, setCompanyDetails] = useState("");
  const dispacth = useDispatch();
  const toggleSetting = (key) => {
    setSettings({ ...settings, [key]: !settings[key] });
  };

  const settingsList = [
    { key: "otpVerification", label: "Login OTP - RetailxCross" },
    { key: "mobileVerification", label: "Mobile Verification - RetailxApp" },
    { key: "retailxCrossLogin", label: "Login OTP - RetailxApp Website" },
    {
      key: "orderReceivedCompany",
      label: "Order Received Message on Company Mobile",
    },
    { key: "orderDeliveredOTP", label: "Order Delivered OTP Customer Mobile" },
  ];

  const settingList2 = [
    {
      key: "orderAcceptedCustomer",
      label: "Order Accepted Message to Customer Mobile",
    },
    {
      key: "orderRejectedCustomer",
      label: "Order Rejected Message to Customer Mobile",
    },
    {
      key: "orderDispatchedCustomer",
      label: "Order Dispatched Message to Customer Mobile",
    },
    {
      key: "billLinkCustomer",
      label: "Bill Link Send on Customer Mobile Message",
    },
    { key: "orderAssignedDelivery", label: "Order Assigned for Delivery" },
  ];
  const navigate = useNavigate();

  const saveWhatsappSettings = () => {
    if (companyDetails?.company_email) {
      dispacth(setSpinnerLoading("Loading"));
      CallAPIPromise("/api/whatsAppSender/saveWhatsappSenderSettings", {
        company_email: companyDetails?.company_email,
        otp_rxc_login: settings.otpVerification ? 1 : 0,
        otp_rxc_mobile_verify: settings.mobileVerification ? 1 : 0,
        otp_rxc_website_login: settings.retailxCrossLogin ? 1 : 0,
        otp_order_rcvd_company_mobile: settings.orderReceivedCompany ? 1 : 0,
        otp_order_devd_customer_mobile: settings.orderDeliveredOTP ? 1 : 0,
        order_acpt_msg_cusomer_mobile: settings.orderAcceptedCustomer ? 1 : 0,
        order_rejc_msg_cusomer_mobile: settings.orderRejectedCustomer ? 1 : 0,
        order_disp_msg_cusomer_mobile: settings.orderDispatchedCustomer ? 1 : 0,
        bill_link_msg_cusomer_mobile: settings.billLinkCustomer ? 1 : 0,
        order_assign_msg_dlv_emp: settings.orderAssignedDelivery ? 1 : 0,
      }).then(() => {
        dispacth(
          setAlertWithTitle({
            title: "Success",
            msg: "Data saved successfully",
          })
        );
        setWhastappBalance(0);
        setSettings({
          otpVerification: false,
          mobileVerification: false,
          retailxCrossLogin: false,
          orderReceivedCompany: false,
          orderAcceptedCustomer: false,
          orderRejectedCustomer: false,
          orderDispatchedCustomer: false,
          billLinkCustomer: false,
          orderDeliveredOTP: false,
          orderAssignedDelivery: false,
          sendAppQrCompany: false,
        });
        setCompanyDetails("");
      });
    } else {
      dispacth(
        setAlertWithTitle({
          title: "Alert",
          msg: "Company required",
        })
      );
    }
  };

  useEffect(() => {
    if (companyDetails?.company_email) {
      CallAPIPromise(
        `/api/whatsApp/loadMessageBalance`,
        {
          company_email: companyDetails?.company_email,
        },
        token
      ).then((res) => {
        if (res.status === 200) {
          setWhastappBalance(res.data.response[0].whatsapp_balance);
        }
      });
    }
  }, [companyDetails?.company_email]);

  return (
    <div className="w-full flex justify-center bg-[#f5f5f7] h-full px-3">
      <div className="text-sm rounded-sm flex flex-col w-[1024px]  h-full py-4 ">
        <div>
          <ModalHeaderStyle
            logo={
              <i className="bi bi-whatsapp items-center flex text-[#25D366] text-[24px] mr-2 " />
            }
            header={"WhatsApp Sender Settings"}
            onClose={() => {
              navigate("/masters");
            }}
          />
        </div>
        <div className="p-6  bg-white shadow-sm rounded overflow-y-auto">
          <div className="grid grid-cols-3 gap-3">
            <GeniustextInput
              type={"text"}
              search={() => {
                setCompanyHelpStatus(true);
              }}
              title={"Company Email"}
              error={false}
              value={
                companyDetails?.company_email
                  ? companyDetails?.company_email
                  : ""
              }
              onChange={(t) => {}}
              maxLength={100}
              grid={true}
            />{" "}
            <GeniustextInput
              type={"text"}
              grid={true}
              title={"Company Name"}
              error={false}
              value={
                companyDetails?.company_name ? companyDetails?.company_name : ""
              }
              onChange={(t) => {}}
              maxLength={100}
            />
            <GeniustextInput
              type={"text"}
              grid={true}
              title={"Whatasapp Balance"}
              error={false}
              value={whatsappBalance}
              onChange={(t) => {}}
              maxLength={100}
            />
          </div>

          <div className="">
            <div className="font-semibold mb-1 text-red-500">OTP Message</div>
            <div className="border rounded-sm p-3 space-y-4">
              {settingsList.map((item) => (
                <div
                  key={item.key}
                  className="flex justify-between items-center"
                >
                  <span>{item.label}</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={settings[item.key]}
                      onChange={() => toggleSetting(item.key)}
                      className="sr-only peer"
                    />
                    {/* Track */}
                    <div className="w-11 h-6 bg-red-200 rounded-full peer peer-checked:bg-[#25D366] transition-colors"></div>
                    {/* Knob */}
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform peer-checked:translate-x-5 transition-transform"></div>
                  </label>
                </div>
              ))}
            </div>
            <div className="border-t my-4"></div>
            <div className="font-semibold mb-1 text-red-500">
              Customer Message
            </div>

            <div className="border rounded-sm p-3 space-y-4">
              {settingList2.map((item) => (
                <div
                  key={item.key}
                  className="flex justify-between items-center"
                >
                  <span>{item.label}</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={settings[item.key]}
                      onChange={() => toggleSetting(item.key)}
                      className="sr-only peer"
                    />
                    {/* Track */}
                    <div className="w-11 h-6 bg-red-200 rounded-full peer peer-checked:bg-[#25D366] transition-colors"></div>
                    {/* Knob */}
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform peer-checked:translate-x-5 transition-transform"></div>
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-end mt-3">
            <div className="flex">
              <SaveButton onClick={saveWhatsappSettings} />
              <ExitButton
                onClick={() => {
                  navigate("/settings");
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <CompanyHelp
        status={companyHelpStatus}
        onClose={() => {
          setCompanyHelpStatus(false);
        }}
        onRowClick={(p) => {
          setCompanyHelpStatus(false);
          setCompanyDetails(p.row);

          CallAPIPromise(
            "/api/loadWhatsAppSenderSetting/loadWhatsAppSenderSettings",
            {
              company_email: p.row.company_email,
            }
          ).then((res) => {
            console.log(res);
            if (res.data.response[0]) {
              const data = res.data.response[0];
              setSettings({
                otpVerification: data.otp_rxc_login === 1 ? true : false,
                mobileVerification:
                  data.otp_rxc_mobile_verify === 1 ? true : false,
                retailxCrossLogin:
                  data.otp_rxc_website_login === 1 ? true : false,
                orderReceivedCompany:
                  data.otp_order_rcvd_company_mobile === 1 ? true : false,
                orderAcceptedCustomer:
                  data.order_acpt_msg_cusomer_mobile === 1 ? true : false,
                orderRejectedCustomer:
                  data.order_rejc_msg_cusomer_mobile === 1 ? true : false,
                orderDispatchedCustomer:
                  data.order_disp_msg_cusomer_mobile === 1 ? true : false,
                billLinkCustomer:
                  data.bill_link_msg_cusomer_mobile === 1 ? true : false,
                orderDeliveredOTP:
                  data.otp_order_devd_customer_mobile === 1 ? true : false,
                orderAssignedDelivery:
                  data.order_assign_msg_dlv_emp === 1 ? true : false,
                sendAppQrCompany: false,
              });
            } else {
              setSettings({
                otpVerification: false,
                mobileVerification: false,
                retailxCrossLogin: false,
                orderReceivedCompany: false,
                orderAcceptedCustomer: false,
                orderRejectedCustomer: false,
                orderDispatchedCustomer: false,
                billLinkCustomer: false,
                orderDeliveredOTP: false,
                orderAssignedDelivery: false,
                sendAppQrCompany: false,
              });
            }
          });
        }}
      />
    </div>
  );
};

export default WhastappSenderSettings;
